import { render, staticRenderFns } from "./setGoodsValue.vue?vue&type=template&id=b3174a6a&scoped=true"
import script from "./setGoodsValue.vue?vue&type=script&lang=js"
export * from "./setGoodsValue.vue?vue&type=script&lang=js"
import style0 from "./setGoodsValue.vue?vue&type=style&index=0&id=b3174a6a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3174a6a",
  null
  
)

export default component.exports